import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subject, Observable, BehaviorSubject, of, throwError } from "rxjs";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { map, tap, shareReplay, catchError } from "rxjs/operators";
import { Admins } from "./model";
import { AuthService } from "../authServices";
import { ConfigService } from "src/app/services/config.service";

@Injectable({
  providedIn: "root",
})
export class AdminProfileService {
  activeData = new BehaviorSubject<boolean | null>(null);
  onActive = this.activeData.asObservable();
  private subordinate: Admins[] = [];
  private subordinateUpdate = new Subject<{ subordinate: Admins[] }>();
  BACKEND_URL: string;

  /** Per-user profile cache — prevents one user's profile from being served to another. */
  private profileCache = new Map<string, any>();
  private pendingRequests = new Map<string, Observable<any>>();

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService,
    private Auth: AuthService,
    private configService: ConfigService,
  ) {
    this.BACKEND_URL = this.configService.get('apiUrl') + '/admin';

    // Clear cache on profile updates, role changes, login, and logout
    this.Auth.imageUpdated$.subscribe(() => this.clearCache());
    this.Auth.roleChanged$.subscribe(() => this.clearCache());
    this.Auth.getAuthStatusListener().subscribe(() => this.clearCache());
  }

  clearCache() {
    this.profileCache.clear();
    this.pendingRequests.clear();
  }

  getByID(id: string): Observable<any> {
    if (!id) {
      return throwError(() => new Error('Profile fetch requires a user ID'));
    }

    const cached = this.profileCache.get(id);
    if (cached) {
      return of(cached);
    }

    const pending = this.pendingRequests.get(id);
    if (pending) {
      return pending;
    }

    let roleName = this.Auth.getRoleName();
    const roleQuery = roleName
      ? `&roleName=${encodeURIComponent(roleName)}`
      : "";

    const request$ = this.http.get<any>(
      this.BACKEND_URL + "/get-profile/" + id + `?name=Get Profile${roleQuery}`
    ).pipe(
      tap((res) => {
        this.profileCache.set(id, res);
        this.pendingRequests.delete(id);
      }),
      catchError((err) => {
        this.pendingRequests.delete(id);
        return throwError(() => err);
      }),
      shareReplay(1)
    );

    this.pendingRequests.set(id, request$);
    return request$;
  }
  updateProfilePic(profile_image: File | string): Observable<any> {
    const Data = new FormData();
    const roleName = this.Auth.getRoleName();
    const roleQuery = roleName ? `&roleName=${encodeURIComponent(roleName)}` : "";
  
    Data.append("profile_image", profile_image);
  
    return this.http.put(
      `${this.BACKEND_URL}/update/profile?name=Update Profile Pic${roleQuery}`,
      Data
    );
  }

  updateSignature(signature_image: File | string) {
    let Data = new FormData();

    Data.append("signature_image", signature_image);

    return this.http
      .put(this.BACKEND_URL + "/update/signature_image", Data)
  }

  // updatePassword(
  //   passwordCurrent: string,
  //   password: string,
  //   passwordConfirm: string
  // ) {
  //   let Data = {
  //     passwordCurrent: passwordCurrent,
  //     password: password,
  //     passwordConfirm: passwordConfirm,
  //   };
  //   let roleName = this.Auth.getRoleName();
  //   const roleQuery = roleName
  //     ? `&roleName=${encodeURIComponent(roleName)}`
  //     : "";
  //   this.http
  //     .patch(BACKEND_URL + `/updateMyPassword?name=Update Password${roleQuery}`, Data)
  //     .subscribe((response) => {
  //       if (response) {
  //         setTimeout(() => {
  //           this.toastr.success("Done!", "Password Change Successfully.", {
  //             timeOut: 2500,
  //             closeButton: true,
  //           });
  //         }, 400);
  //       }
  //     });
  // }

  updatePassword(
  passwordCurrent: string,
  password: string,
  passwordConfirm: string
) {
  const Data = {
    passwordCurrent,
    password,
    passwordConfirm,
  };

  const roleName = this.Auth.getRoleName();
  const roleQuery = roleName ? `&roleName=${encodeURIComponent(roleName)}` : "";

  return this.http.patch(this.BACKEND_URL + `/updateMyPassword?name=Update Password${roleQuery}`, Data);
}
  set setactiveData(active: boolean) {
    this.activeData.next(active);
  }
}
